// Centralized mock data. Backend will later replace dynamic parts (contact form).

export const company = {
  name: 'Interscope Ads',
  legalName: 'Interscope Tech Media Private Limited',
  tagline: 'Performance Marketing Built to Scale',
  phone: '+91 9266892330',
  whatsapp: '919266892330',
  email: 'support@interscopeads.in',
  location: 'Global \u2014 HQ in India',
  instagram: 'https://www.instagram.com/interscope_ads/',
  linkedin: 'https://in.linkedin.com/company/interscope-tech-media-private-limited',
};

export const navLinks = [
  { label: 'Solutions', to: '/solutions' },
  { label: 'Industries', to: '/industries' },
  { label: 'Performance', to: '/performance' },
  { label: 'Case Studies', to: '/case-studies' },
  { label: 'Insights', to: '/blog' },
  { label: 'About', to: '/about' },
  { label: 'Contact', to: '/contact' },
];

export const geos = [
  { name: 'United States', code: 'us' },
  { name: 'India', code: 'in' },
  { name: 'Indonesia', code: 'id' },
  { name: 'United Kingdom', code: 'gb' },
  { name: 'Canada', code: 'ca' },
  { name: 'United Arab Emirates', code: 'ae' },
  { name: 'Saudi Arabia', code: 'sa' },
  { name: 'Kuwait', code: 'kw' },
  { name: 'Mexico', code: 'mx' },
  { name: 'Brazil', code: 'br' },
  { name: 'Turkey', code: 'tr' },
  { name: 'Vietnam', code: 'vn' },
  { name: 'Philippines', code: 'ph' },
  { name: 'Russia', code: 'ru' },
  { name: 'Spain', code: 'es' },
  { name: 'Denmark', code: 'dk' },
  { name: 'Japan', code: 'jp' },
  { name: 'Qatar', code: 'qa' },
];

export const clients = [
  { name: 'Gizmo', logo: '/gizmo-ai-logo.png' },
  { name: 'TILT Shopping', logo: '/tilt-logo.png' },
  { name: 'Practo', logo: 'https://www.google.com/s2/favicons?sz=128&domain=practo.com' },
  { name: 'LenDenClub', logo: 'https://www.google.com/s2/favicons?sz=128&domain=lendenclub.com' },
  { name: 'Acorns', logo: 'https://www.google.com/s2/favicons?sz=128&domain=acorns.com' },
  { name: 'Careem', logo: 'https://www.google.com/s2/favicons?sz=128&domain=careem.com' },
  { name: 'InstaMoney', logo: 'https://www.google.com/s2/favicons?sz=128&domain=instamoney.app' },
  { name: 'ARKANA', logo: 'https://www.google.com/s2/favicons?sz=128&domain=arkana.consulting' },
  { name: 'Zoomd', logo: 'https://www.google.com/s2/favicons?sz=128&domain=zoomd.com' },
  { name: 'US Media', logo: 'https://www.google.com/s2/favicons?sz=128&domain=usmediaconsulting.com' },
  { name: 'Delta Exchange', logo: 'https://www.google.com/s2/favicons?sz=128&domain=delta.exchange' },
];

export const stats = [
  { value: 500, suffix: 'M+', label: 'Monthly Impressions' },
  { value: 150, suffix: '+', label: 'Global Markets' },
  { value: 1000, suffix: '+', label: 'Active Campaigns' },
  { value: 100, suffix: '+', label: 'Growth Partners' },
];

// Performance numbers section (editable)
export const performanceStats = [
  { value: 500, suffix: 'M+', label: 'Monthly Impressions' },
  { value: 150, suffix: '+', label: 'Global Markets' },
  { value: 1000, suffix: '+', label: 'Active Campaigns' },
  { value: 50, suffix: 'M+', label: 'Users Acquired' },
  { value: 100, suffix: '+', label: 'Growth Partners' },
];

// Hero dashboard live metrics (demo/sample data)
export const heroDashboardMetrics = [
  { label: 'Impressions', value: '48.2M', trend: '+12.4%' },
  { label: 'Clicks', value: '1.94M', trend: '+8.1%' },
  { label: 'Installs', value: '312K', trend: '+18.7%' },
  { label: 'Conversions', value: '86.5K', trend: '+9.3%' },
  { label: 'ROAS', value: '3.8x', trend: '+0.6x' },
  { label: 'Revenue', value: '$1.42M', trend: '+21%' },
];
export const heroChart = [38, 44, 40, 52, 49, 61, 58, 70, 66, 78, 74, 88];
export const heroFloatingLabels = ['Global Reach', 'Data-Driven', 'Performance Focused', 'Scale Faster'];

export const trustCategories = [
  { name: 'Mobile Apps', icon: 'Smartphone' },
  { name: 'Gaming', icon: 'Gamepad2' },
  { name: 'Fintech', icon: 'Landmark' },
  { name: 'E-commerce', icon: 'ShoppingBag' },
  { name: 'Entertainment', icon: 'Clapperboard' },
  { name: 'SaaS', icon: 'CloudCog' },
  { name: 'Consumer Apps', icon: 'AppWindow' },
];

export const services = [
  {
    slug: 'mobile-user-acquisition',
    title: 'Mobile User Acquisition',
    icon: 'Smartphone',
    short: 'Acquire high-quality users through scalable app growth campaigns.',
    long: 'From install to LTV \u2014 we drive quality users that convert. Deep MMP integrations, fraud-free traffic and event-optimized campaigns tuned to your KPIs across global geos.',
    features: ['Quality Installs at Scale', 'MMP Integrations', 'Event Optimization', 'LTV-based Bidding', 'Fraud Prevention'],
  },
  {
    slug: 'retargeting',
    title: 'Retargeting',
    icon: 'Repeat',
    short: 'Re-engage existing users and bring high-value users back to your app.',
    long: 'Win back dormant users and lift lifetime value with predictive audiences, dynamic creative and cross-device retargeting across push, in-app and paid channels.',
    features: ['Dynamic Creative', 'Churn Prediction', 'Cross-Device Reach', 'Lifecycle Journeys', 'Payday Timing'],
  },
  {
    slug: 'ctv-advertising',
    title: 'CTV Advertising',
    icon: 'Tv',
    short: 'Reach audiences through connected TV and premium video inventory.',
    long: 'Premium, brand-safe CTV/OTT placements across leading FAST platforms. Full measurement from impression to installs so TV finally becomes accountable, performance media.',
    features: ['Premium OTT Inventory', 'Brand-safe Placements', 'Cross-screen Measurement', 'Household Targeting', 'View-through Attribution'],
  },
  {
    slug: 'programmatic-advertising',
    title: 'Programmatic Advertising',
    icon: 'Cpu',
    short: 'Data-driven media buying across premium global inventory.',
    long: 'Real-time programmatic buying across DSPs and native, display and video exchanges, optimized to your down-funnel events with layered audience and fraud controls.',
    features: ['DSP & Native Buying', 'Audience Layering', 'Real-time Bidding', 'Supply-path Optimization', 'Fraud Controls'],
  },
  {
    slug: 'performance-marketing',
    title: 'Performance Marketing',
    icon: 'Target',
    short: 'Campaigns optimized around measurable business outcomes.',
    long: 'Full-funnel paid media engineered around your unit economics. Every rupee is tracked to a business outcome \u2014 CPA, CPI, CPL or ROAS \u2014 with relentless optimization.',
    features: ['CPA / CPI / CPL / ROAS', 'Creative Testing', 'Bid Automation', 'Unit-economics Modelling', 'Real-time Optimization'],
  },
  {
    slug: 'lead-generation',
    title: 'Lead Generation',
    icon: 'UserPlus',
    short: 'Generate high-intent leads through performance-driven acquisition.',
    long: 'Quality-scored lead generation across search, social and affiliates with landing-page CRO and automated nurture that fills your pipeline with buyers, not just contacts.',
    features: ['Quality Scoring', 'Landing-page CRO', 'Lead Nurture Automation', 'Intent Targeting', 'CRM Integration'],
  },
  {
    slug: 'affiliate-marketing',
    title: 'Affiliate Marketing',
    icon: 'Handshake',
    short: 'Build scalable acquisition through trusted performance partners.',
    long: 'Tap into our vetted network of performance partners. Pure outcomes \u2014 you pay for results, not promises \u2014 with full anti-fraud monitoring and real-time reporting.',
    features: ['Vetted Partner Network', 'CPA / CPI / CPL Models', 'Anti-fraud Monitoring', 'Real-time Reporting', 'Global Coverage'],
  },
  {
    slug: 'app-growth',
    title: 'App Growth',
    icon: 'TrendingUp',
    short: 'Full-funnel strategies focused on installs, activation, retention and revenue.',
    long: 'End-to-end app growth: we align acquisition, activation, retention and monetization into one measurable engine that compounds LTV over time.',
    features: ['Full-funnel Strategy', 'Activation & Onboarding', 'Retention Loops', 'Monetization', 'LTV Optimization'],
  },
];

export const expertise = [
  { title: 'Analytics', icon: 'BarChart3', desc: 'Advanced analytics tools to track user behavior, campaign performance, and key KPIs for continuous improvement.' },
  { title: 'Conversion Rate', icon: 'TrendingUp', desc: 'A/B testing, funnel analysis, and UX design that turn visitors into loyal customers with higher ROI.' },
  { title: 'Content Strategy', icon: 'PenTool', desc: 'Tailored content plans that resonate with your audience, boost SEO, and support lead generation goals.' },
  { title: 'Audience Targeting', icon: 'Users', desc: 'Data-driven segmentation ensures your message reaches the right users at the right time on the right platforms.' },
  { title: 'Multi-Channel Campaigns', icon: 'Layers', desc: 'We integrate search, display, video, email, and social to maximize your brand\u2019s digital footprint.' },
  { title: 'Marketing Automation', icon: 'Workflow', desc: 'Automated journeys and lifecycle campaigns that nurture leads and re-engage users on autopilot.' },
];

export const processSteps = [
  { step: '01', title: 'Strategy', desc: 'Understand the business, audience and growth objectives to define the right KPIs.' },
  { step: '02', title: 'Launch', desc: 'Build campaigns, tracking and media strategy across the right channels and geos.' },
  { step: '03', title: 'Optimize', desc: 'Continuously analyze performance and optimize traffic, audiences and creatives.' },
  { step: '04', title: 'Scale', desc: 'Increase volume while maintaining agreed KPIs and performance targets.' },
];

export const values = [
  { icon: 'Globe2', title: 'Global Expertise', desc: 'A globally data-driven performance marketing company helping clients maximize brand visibility and ROI.' },
  { icon: 'Rocket', title: 'User Acquisition', desc: 'We leverage our inventory to deliver both quality and volume \u2014 installs, registrations, transactions and sales.' },
  { icon: 'Gauge', title: '360\u00b0 Measurable Strategy', desc: 'A live 360-degree measurable strategy. We\u2019re more about you and your growth than we are about us.' },
  { icon: 'Sparkles', title: 'Expert Team', desc: 'Specialists across strategy, design and technology delivering solutions that look great and perform exceptionally.' },
];

export const team = [
  { name: 'Aarav Mehta', role: 'Founder & CEO', img: 'https://i.pravatar.cc/300?img=12' },
  { name: 'Sara Khan', role: 'Head of Performance', img: 'https://i.pravatar.cc/300?img=45' },
  { name: 'Rohan Verma', role: 'Director, Growth', img: 'https://i.pravatar.cc/300?img=33' },
  { name: 'Priya Nair', role: 'Creative Lead', img: 'https://i.pravatar.cc/300?img=27' },
];

export const testimonials = [
  { name: 'Nikhil Rao', title: 'VP Growth, FinTech App', quote: 'Interscope scaled our installs 4x in a single quarter while cutting CPA by 38%. Their data discipline is unmatched.', img: 'https://i.pravatar.cc/120?img=15' },
  { name: 'Meera Joshi', title: 'CMO, D2C Brand', quote: 'The most transparent agency we\u2019ve worked with. Every rupee is tracked to revenue. ROAS went from 2.1 to 5.6.', img: 'https://i.pravatar.cc/120?img=48' },
  { name: 'Daniel Cooper', title: 'Growth Lead, Gaming', quote: 'Fraud-free traffic at real scale. They plugged into our MMP and optimized to in-app events flawlessly.', img: 'https://i.pravatar.cc/120?img=53' },
];

export const caseStudies = [
  {
    slug: 'acorns',
    brand: 'Acorns',
    logo: '/acorns-logo.png',
    category: 'Fintech \u2022 App User Acquisition',
    featured: true,
    verified: 'Adjust verified',
    date: 'Sep\u2013Dec 2025',
    image: 'https://images.unsplash.com/photo-1645226880663-81561dcab0ae?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
    tagline: 'Driving First-Time Recurring Investments at scale across the US.',
    industry: 'Fintech / Investing',
    market: 'United States',
    objective: 'First-Time Recurring Investments',
    campaignType: 'Pay-per-FRIRT',
    installs: '227K+',
    cpi: 'CAC < $70',
    conversionRate: '13\u201315% install\u2192registration',
    roas: '\u2014',
    keyResults: '5,097 recurring investors \u00b7 227K+ installs \u00b7 77.4K+ registrations',
    metrics: [
      { label: 'Installs', value: '227K+' },
      { label: 'Registrations', value: '77.4K+' },
      { label: 'Recurring Inv.', value: '5,097' },
    ],
  },
];

export const performanceModel = {
  headline: 'Performance-driven growth \u2014 you only pay after your users pay you',
  desc: 'No prepayment. We focus purely on revenue-generating users, so you pay us only after we successfully deliver results.',
  pillars: [
    { icon: 'Crosshair', title: 'Precision Targeting', desc: 'Advanced demographic and behavioral segmentation for maximum ROI.' },
    { icon: 'LayoutGrid', title: 'Diverse Ad Inventory', desc: 'Display, native, in-app, video and banner placements across global markets.' },
    { icon: 'Globe2', title: 'Global Brand Awareness', desc: 'Strategic brand promotion to reach expansive user bases worldwide.' },
  ],
};

export const funnelStages = [
  { icon: 'Megaphone', title: 'Acquisition', desc: 'Reach users to build awareness and convert prospects into installs using CPI models.' },
  { icon: 'Zap', title: 'Activation', desc: 'Smooth onboarding that drives first-open and registration through meaningful early interactions.' },
  { icon: 'Repeat', title: 'Retention', desc: 'D1, D7 and D30 engagement via personalized push and in-app retargeting to foster loyalty.' },
  { icon: 'DollarSign', title: 'Revenue', desc: 'Monetize high-value in-app actions \u2014 purchases, subscriptions and deposits \u2014 at optimized cost.' },
];

export const verticals = [
  'Food & Delivery', 'Finance / FinTech', 'E-commerce / Shopping',
  'Gaming', 'Productivity & Utilities', 'Social Apps',
];

export const trafficSources = [
  'OEM (Samsung, Xiaomi, OPPO, vivo, Huawei)', 'Programmatic In-App', 'Native Advertising',
  'Display Advertising', 'Connected TV (CTV / OTT)', 'Creator-led Video',
  'Global Social', 'DSP Partners',
];

export const partners = [
  'AppLovin', 'Moloco', 'Mintegral', 'Chartboost', 'AdColony', 'Smadex',
  'Glance', 'ShareChat', 'Unruly', 'Meta', 'Search Ads', 'Baidu',
];

// ===== Performance Intelligence funnel: "Every Click Has a Story" =====
export const journeyStages = [
  { key: 'impression', label: 'Impression', metric: '48.2M', sub: 'Monthly reach', action: 'Premium, brand-safe inventory across OEM, programmatic & CTV.' },
  { key: 'click', label: 'Click', metric: '1.94M', sub: '4.0% CTR', action: 'Creative A/B testing and placement optimization lift engagement.' },
  { key: 'install', label: 'Install', metric: '312K', sub: '16% CVR', action: 'Bid-to-install optimization with real-time fraud filtering.' },
  { key: 'registration', label: 'Registration', metric: '241K', sub: '77% of installs', action: 'Onboarding-event optimization drives first-open & sign-up.' },
  { key: 'purchase', label: 'Purchase', metric: '86.5K', sub: '$1.48 CPA', action: 'Purchase-event bidding targets high-intent, high-LTV users.' },
  { key: 'retention', label: 'Retention', metric: '42%', sub: 'D30 retained', action: 'Lifecycle retargeting and re-engagement keep users active.' },
  { key: 'revenue', label: 'Revenue', metric: '$1.42M', sub: '3.8x ROAS', action: 'LTV-based scaling compounds revenue while holding KPIs.' },
];

// ===== Global reach regions (abstract map node positions in %) =====
export const regions = [
  { name: 'North America', x: 20, y: 34 },
  { name: 'LATAM', x: 28, y: 66 },
  { name: 'Europe', x: 50, y: 30 },
  { name: 'MENA', x: 58, y: 46 },
  { name: 'India', x: 70, y: 50 },
  { name: 'APAC', x: 82, y: 40 },
];

// Real-world lat/lng for the interactive 3D globe
export const regionsGeo = [
  { name: 'North America', lat: 39, lng: -98 },
  { name: 'LATAM', lat: -14, lng: -51 },
  { name: 'Europe', lat: 51, lng: 10 },
  { name: 'MENA', lat: 24, lng: 54 },
  { name: 'India', lat: 22, lng: 79 },
  { name: 'APAC', lat: 1.3, lng: 103 },
];

// ===== Industries / verticals =====
export const industries = [
  { name: 'Apps', icon: 'AppWindow', desc: 'Scalable installs, activation and retention for consumer and utility apps.' },
  { name: 'Gaming', icon: 'Gamepad2', desc: 'High-LTV player acquisition and reactivation across global markets.' },
  { name: 'Fintech', icon: 'Landmark', desc: 'Compliant, quality-first acquisition for funded accounts and deposits.' },
  { name: 'E-commerce', icon: 'ShoppingBag', desc: 'First-purchase and repeat-buyer growth with ROAS-led media buying.' },
  { name: 'Entertainment', icon: 'Clapperboard', desc: 'Subscriptions, streams and engagement across social, video and CTV.' },
  { name: 'Travel', icon: 'Plane', desc: 'Demand generation and bookings across seasonal, high-intent audiences.' },
  { name: 'SaaS', icon: 'CloudCog', desc: 'High-intent B2B and prosumer lead generation with CRM-tracked pipeline.' },
  { name: 'Lifestyle', icon: 'HeartPulse', desc: 'Habit-forming apps scaled through creative-led, data-driven UA.' },
];

// ===== Technology & tracking =====
export const integrations = [
  { name: 'Google Ads', slug: 'googleads' },
  { name: 'Meta', slug: 'meta' },
  { name: 'TikTok', slug: 'tiktok' },
  { name: 'Snapchat', slug: 'snapchat' },
  { name: 'YouTube', slug: 'youtube' },
  { name: 'Unity Ads', slug: 'unity' },
  { name: 'AppsFlyer', slug: 'appsflyer' },
  { name: 'Adjust', slug: 'adjust' },
  { name: 'Singular', slug: 'singular' },
  { name: 'The Trade Desk', slug: 'thetradedesk' },
  { name: 'DV360', slug: null },
  { name: 'Moloco', slug: null },
];
export const capabilities = [
  { icon: 'Radar', title: 'MMP Tracking', desc: 'Deep integrations with leading mobile measurement partners.' },
  { icon: 'GitBranch', title: 'Attribution', desc: 'Multi-touch attribution mapped to real business outcomes.' },
  { icon: 'MousePointerClick', title: 'Conversion Tracking', desc: 'Event-level tracking from impression to revenue.' },
  { icon: 'Gauge', title: 'Real-Time Optimization', desc: 'Live bid, audience and creative optimization at scale.' },
  { icon: 'ShieldCheck', title: 'Fraud Monitoring', desc: 'Proactive anti-fraud filtering protects your spend.' },
  { icon: 'Users', title: 'Audience Segmentation', desc: 'Granular, data-driven segments for precise targeting.' },
  { icon: 'BarChart3', title: 'Campaign Analytics', desc: 'Unified dashboards across every channel and geo.' },
  { icon: 'Target', title: 'KPI Monitoring', desc: 'Continuous tracking against agreed performance targets.' },
];

// ===== Why Interscope =====
export const whyInterscope = [
  { icon: 'Zap', title: 'Performance First', desc: 'Every decision optimized around measurable business outcomes, not vanity metrics.' },
  { icon: 'Globe2', title: 'Global Scale', desc: 'Campaigns that scale across 150+ markets, from emerging to mature economies.' },
  { icon: 'Database', title: 'Data-Driven Decisions', desc: 'Optimization powered by real-time data and full-funnel signals.' },
  { icon: 'Eye', title: 'Transparent Reporting', desc: 'Live, granular reporting so you always know where every rupee goes.' },
  { icon: 'Settings2', title: 'Dedicated Optimization', desc: 'Hands-on teams continuously tuning traffic, audiences and creatives.' },
  { icon: 'BadgeCheck', title: 'Quality-Focused Acquisition', desc: 'We acquire users that convert and retain \u2014 not just cheap installs.' },
];

// ===== Client dashboard demo (sample data) =====
export const dashboardDemo = {
  metrics: [
    { label: 'Spend', value: '$125,000' },
    { label: 'Installs', value: '84,500' },
    { label: 'CPA', value: '$1.48' },
    { label: 'ROAS', value: '3.8x' },
    { label: 'Conversion Rate', value: '6.7%' },
    { label: 'Retention', value: '42%' },
  ],
  spendBars: [42, 55, 48, 63, 70, 66, 78, 85, 80, 92, 88, 100],
  revenueLine: [20, 28, 26, 38, 44, 52, 60, 66, 74, 82, 90, 98],
  channelSplit: [
    { label: 'OEM', pct: 34 },
    { label: 'Programmatic', pct: 26 },
    { label: 'CTV', pct: 18 },
    { label: 'Social', pct: 14 },
    { label: 'Affiliate', pct: 8 },
  ],
};

// ===== About =====
export const about = {
  intro: 'Interscope is a global performance marketing and mobile user acquisition agency. We help brands and apps acquire high-quality users, drive measurable growth and scale performance across global markets.',
  points: [
    { icon: 'Crosshair', title: 'What we specialize in', desc: 'Mobile user acquisition, retargeting, CTV, programmatic, performance marketing, lead generation and affiliate growth.' },
    { icon: 'LineChart', title: 'Our approach', desc: 'Acquire. Optimize. Scale. Every campaign is engineered around measurable outcomes and continuous optimization.' },
    { icon: 'Globe2', title: 'Global capabilities', desc: 'Reach across North America, Europe, MENA, LATAM, APAC and India through a diversified inventory ecosystem.' },
    { icon: 'Cpu', title: 'Technology', desc: 'MMP tracking, attribution, fraud monitoring and real-time optimization power everything we run.' },
  ],
};

// ===== Contact form options =====
export const contactOptions = {
  industries: ['Mobile Apps', 'Gaming', 'Fintech', 'E-commerce', 'Entertainment', 'Travel', 'SaaS', 'Lifestyle', 'Other'],
  budgets: ['< $10k / mo', '$10k \u2013 $50k / mo', '$50k \u2013 $100k / mo', '$100k \u2013 $500k / mo', '$500k+ / mo'],
  campaignTypes: ['Mobile User Acquisition', 'Retargeting', 'CTV Advertising', 'Programmatic', 'Performance Marketing', 'Lead Generation', 'Affiliate Marketing', 'App Growth'],
};

// ===== CPA/ROAS Calculator defaults (editable, illustrative) =====
export const calculatorDefaults = {
  budget: 50000,      // monthly ad budget ($)
  cpi: 1.5,           // target cost per install ($)
  cvr: 6,             // install -> paying user conversion (%)
  arpu: 35,           // revenue per paying user ($)
};

export const faqs = [
  { q: 'What industries do you specialize in?', a: 'We drive growth across Food & Delivery, Finance/FinTech, E-commerce & Shopping, Gaming, Productivity & Utilities and Social apps \u2014 anywhere performance and measurable outcomes matter.' },
  { q: 'How do you measure success?', a: 'Every engagement is tied to your core business KPIs \u2014 installs, registrations, subscriptions, ROAS, CAC or revenue \u2014 with a live 360\u00b0 measurable dashboard (Adjust / AppsFlyer verified).' },
  { q: 'Do you really only get paid after we do?', a: 'Yes. We focus purely on performance-driven growth \u2014 no prepayment. You pay us only after we deliver revenue-generating users who pay you.' },
  { q: 'What traffic sources do you use?', a: 'OEM (Samsung, Xiaomi, OPPO, vivo, Huawei), programmatic in-app, native, display, CTV/OTT, creator-led video, global social and DSP partners \u2014 all fraud-monitored.' },
  { q: 'How quickly can we get started?', a: 'Most clients go live within 7\u201310 days after a discovery and strategy sprint. Book a free consultation to kick off.' },
];
